import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TuiDialogContext } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';

@Component({
	selector: 'mar-dialog-header',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: 'dialog-header.component.html',
	host: { class: 'w-full rounded-t-lg overflow-hidden' },
})
export class DialogHeaderComponent {
	protected readonly context = inject(
		POLYMORPHEUS_CONTEXT,
	) as TuiDialogContext<null, { headerText: string; subheaderText: string }>;
}
